import {getReportParams, report} from 'app/middleware/report';
import EpiContext from '@episerver/spa-core/Spa';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
export function dwhReportBuilder(reportObject) {
    const state = EpiContext.getStore().getState();
    const userDetails = state.authentication.loginData.userDetails;
    const pricePlanState = state.personalPricePlan;
    const PPMetadata = pricePlanState?.selectedPackage?.pricePlanMetadata;
    var PPEffectiveDate = PPMetadata?.isImmediatePlan ? convertDateTimeToDate(new Date()) : PPMetadata?.effectiveDate;
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellular Change Price Plan new';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = reportObject.actionType;
    reportParams.status = reportObject.status;
    reportParams.messageText = reportObject.messageText;

    const paramValues = {
        '1': userDetails?.IsPrimaryContact ? 'איש קשר' : 'מנוי',
        '2': PPMetadata?.isBRB ? 'חבילה ברמת מנוי' : 'חבילה ברמת לקוח',
        '3': pricePlanState?.selectedPackage?.offerID || '',
        '4': isNullOrEmpty(pricePlanState?.recommendationsPPCode) ? '' : pricePlanState?.recommendationsPPCode?.join(','),
        '5': pricePlanState?.selectedSubscribers?.join(',') || '',
        '6': PPMetadata?.transitPrice || '',
        '7': PPEffectiveDate || '',
    };
    (reportObject.params || []).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(paramValues, key)) {
            reportParams[`param${key}`] = paramValues[key];
        }
    });

    reportParams.banId = pricePlanState?.selectedBan || '';
    reportParams.idNumber = userDetails?.IDNumber || '';
    reportParams.customerName = `${userDetails?.firstName} ${userDetails?.lastName}`;
    reportParams.subscriber = userDetails?.contactNumber;
  report(reportParams);
}

export const reportsDictionary = {
    OFFER_PAGE_DISPLAY: {
      actionType: 'Offer Page',
      status: 'Ongoing',
      messageText: 'Offer Page Display',
      params : ['1','4']
    },
    OFFER_PAGE_BUTTON_CLICK: {
      actionType: 'Offer Page',
      status: 'Ongoing',
      messageText: 'Offer Page Button Clicked',
      params : [ '1', '2', '3','4']
    },
    POPUP_OTP_EXTENDED_DISPLAY: {
      actionType: 'Popup OTPEXTENDED',
      status: 'Ongoing',
      messageText: 'Popup OTPEXTENDED Display',
      params : ['1', '2', '3']
    },
    POPUP_OTP_EXTENDED_BUTTON_CLICK: {
      actionType: 'Popup OTPEXTENDED',
      status: 'Ongoing',
      messageText: 'Popup OTPEXTENDED Button Clicked',
      params : ['1', '2', '3']
    },
    POPUP_OTP_EXTENDED_ENTER_OTP: {
      actionType: 'Popup OTPEXTENDED',
      status: 'Ongoing',
      messageText: 'Popup OTPEXTENDED enter OTP',
      params : ['1', '2', '3']
    },
    POPUP_OTP_EXTENDED_SUCCESS: {
      actionType: 'Popup OTPEXTENDED',
      status: 'Ongoing',
      messageText: 'Popup OTPEXTENDED Successful',
      params : ['1', '2', '3']
    },
    SELECT_CELL_NUMBER_PAGE_DISPLAY: {
      actionType: 'Select Cell Number Page',
      status: 'Ongoing',
      messageText: 'Select Cell Number Page Displayed',
      params : ['1', '2', '3', '6', '7']
    },
    SELECT_CELL_NUMBER_BUTTON_CLICK: {
      actionType: 'Select Cell Number Page',
      status: 'Ongoing',
      messageText: 'Selected Cell Number Button Clicked',
      params : ['1', '2', '3','5', '6', '7']
    },
    CHANGE_PRICE_PLAN_SUCCESS: {
      actionType: 'Change Price Plan Successful',
      status: 'Completed',
      messageText: 'Change Price Plan Successful Displayed',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    GENERAL_ERROR: {
      actionType: 'General Error',
      status: 'Error',
      messageText: 'General Error Displayed',
      params : ['1', '2', '3','5', '6', '7']
    },
    CONFIRM_PACKAGE_PAGE_DISPLAY: {
      actionType: 'Confirm Selected Package Page',
      status: 'Ongoing',
      messageText: 'Confirm selected package Page Displayed',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    CONFIRM_PACKAGE_BUTTON_CLICK: {
      actionType: 'Confirm Selected Package Page',
      status: 'Ongoing',
      messageText: 'Confirm selected package Button Clicked',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    CHANGE_PRICE_PLAN_SUCCESS_SINGLE: {
      actionType: 'Change Price Plan Successful Single',
      status: 'Completed',
      messageText: 'Change Price Plan Successful - single',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    ERROR_NO_CELLULAR: {
      actionType: 'Error',
      status: 'Error',
      messageText: 'No Cellular',
      params : ['1']
    },
    ERROR_UNABLE_UPDATE_FAMILY_PACKAGE: {
      actionType: 'Error',
      status: 'Error',
      messageText: 'Unable to update the family package',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    POPUP_WARNING_EXIT_PLAN_DISPLAY: {
      actionType: 'Popup Warning',
      status: 'Ongoing',
      messageText: 'Exiting customer-level plan and change',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    POPUP_WARNING_EXIT_PLAN_OK_CLICK: {
      actionType: 'Popup Warning',
      status: 'Ongoing',
      messageText: 'Exiting customer-level plan and change',
      params : ['1', '2', '3','4','5', '6', '7']
    },
    POPUP_WARNING_EXIT_PLAN_BACK_CLICK: {
      actionType: 'Popup Warning',
      status: 'Ongoing',
      messageText: 'Exiting customer-level plan and change',
      params : ['1', '2', '3','4','5', '6', '7']
    },
  };

